import { checkGenericAuthError } from '@sky-uk/ita-js-common-token-manager';

import { REFRESH_ERROR } from './errors';

export function getFailureAction(actions, auth) {
  return (errorObj) => {
    const genericAuthError = checkGenericAuthError(errorObj.status, errorObj.code);
    if (auth.isUserLogged && genericAuthError === REFRESH_ERROR) {
      return {
        query: actions.setQueryFailure401,
        mutation: actions.setMutationFailure401,
        mutationPrivacy: actions.setMutationPrivacyFailure401,
      };
    }
    return {
      query: actions.setQueryFailureGeneric,
      mutation: actions.setMutationFailureGeneric,
      mutationPrivacy: actions.setMutationPrivacyFailureGeneric,
    };
  };
}
